export enum UserProfessionTypes {
  ELECTRICIAN = 1,
  SEWER = 2,
  DISPATCHER = 3,
  TECHNICAL_MANAGER = 4,
  REPAIR_GROUP_MANAGER = 5,
  ADMINISTRATOR = 6
}
